import { ChevronRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="bg-gray-50 py-4 border-b border-gray-200">
      <div className="container mx-auto px-4">
        <ol className="flex items-center space-x-2 text-sm md:text-base">
          <li>
            <Link to="/" className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
              Home
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center space-x-2">
              <ChevronRight size={16} className="text-gray-400" />
              {index === items.length - 1 ? (
                <span className="text-gray-600 font-semibold">{item.label}</span>
              ) : (
                <Link to={item.path} className="text-[#73BDF2] hover:text-[#5ba8e0] transition-colors duration-300">
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}

export default Breadcrumb;
